import axios from "axios";
import { useContext, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
import { useTranslation } from 'react-i18next';
import { axiosPost } from "../../Apis/axiosMethods";

const AddressCard = ({ item, onDataChanged, backUrl, handleNavigation }) => {
  const { apiURL, token, apiB2BURL } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dir = localStorage.getItem('dir');

  const SetDefaultAddress = async (business_address_id) => {
    setLoading(true);
    try {
      const business_id = localStorage.getItem("business_id");
      const business_user_id = localStorage.getItem("business_user_id");
      const headers = {
        token: token, Accept: "application/json", "Content-Type": "application/json",
        businessid: String(business_id),
        businessuserid: String(business_user_id),
      };
      var formData = {
        business_id: business_id,
        business_address_id: business_address_id

      }
      const response = await axiosPost(`/Users/SetDefaultAddress`, formData);
      onDataChanged();
      setLoading(false);

      // if (backUrl) {
      //   window.location.href = backUrl;
      // }

    } catch (err) {
      setLoading(false);
      console.log("Error While Fetching Customer Addresses", err);
    }
  }

  const DeleteAddress = async (business_address_id) => {
    setDeleting(true);
    try {
      const business_id = localStorage.getItem("business_id");
      var formData = {
        business_id: business_id,
        business_address_id: business_address_id

      }
      const response = await axiosPost(`/Users/DeleteAddress`, formData);
      onDataChanged();
      setDeleting(false);
      if (response.data.success) {
        Swal.fire({
          title: 'Successfully',
          text: response.data.message,
          icon: 'success',
          confirmButtonText: 'Okay'
        })
      } else {
        Swal.fire({
          title: 'Error',
          text: response.data.message,
          icon: 'error',
          confirmButtonText: 'Okay'
        })
      }
    } catch (err) {
      setDeleting(false);
      console.log("Error While Fetching Customer Addresses", err);
    }
  }
  var defText = "";
  return <div className="card" dir={dir} style={{
    textAlign: dir === 'rtl' ? 'right' : '',
    minHeight: '420px', // universal minimum height
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  }}>
    <div className="card-header">

      <div className="float-right">
        {item.default_address === '1' ?
          <span className="badge badge-success">{t("default")}</span>
          : <button onClick={() => SetDefaultAddress(item.business_address_id)}
            className="btn btn-sm btn-primary mx-1"
            title="Set As Default"
            disabled={item.default_address === '1' || loading === true ? true : false} >
            <i className="fa fa-check"></i>
          </button>
        }
        {
          handleNavigation ?
            <button onClick={() => handleNavigation(item.business_address_id)}
              style={{ backgroundColor: "#cc000b", color: "white", }}
              className="btn btn-sm btn-primary mx-1" id="EditAddressBtn" title="Edit"  > <i className="fa fa-edit"></i> </button> : <NavLink to={`/MyAccount/EditAddress/${item.business_address_id}`} style={{ backgroundColor: "#cc000b", color: "white", }} className="btn btn-sm btn-primary mx-1" id="EditAddressBtn" title="Edit"  > <i className="fa fa-edit"></i> </NavLink>
        }

        <button
          disabled={deleting === true ? true : false}
          className="btn btn-sm btn-primary mx-1"
          onClick={() => DeleteAddress(item.business_address_id)}
          title="Remove"
        > <i className="fa fa-trash"></i> </button>

      </div>
    </div>
    <div className="card-body" style={{ flex: 1 }}>
      <div key={item.business_address_id}>
        <div>
          <strong>{t("name")}</strong>
          <p> {item.first_name} {item.last_name} </p>
        </div>
        <div>
          <strong>{t("address")}</strong>
          <p>

            {item.business_full_address},{" "}
            {item.pincode && item.pincode !== '0' && item.pincode !== 0 ? item.pincode + ',' : ''}  <br />
            {item.business_city}
          </p>
        </div>
        <div>
          <strong>{t("phone")}</strong>
          <p>
            {item.mobile_number_1}{" "}
          </p>
        </div>
      </div>
    </div>
  </div>
}

export { AddressCard };